if (!customElements.get('scrolling-banner')) {
  const ScrollingBanner = class extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // Transforms can confuse lazy loading in browsers, so we coordinate loading here
      // Load all countdown timers
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init());
      });

      // Load all images
      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager';
      });

      // After fonts have loaded
      document.fonts.ready.then(() => this.querySelector('.marquee').classList.add('marquee--animate'));

      // Pause/play functionality
      this.togglePlay();
    }

    togglePlay() {
      const pausePlayButton = this.querySelector('.rotation-button');
      const pauseButtonImage = this.querySelector('.pause-container');
      const playButtonImage = this.querySelector('.resume-container');
      const marquee = this.querySelector('.marquee');

      if (pausePlayButton) {
        pausePlayButton.addEventListener('click', (e) => {
          if (pauseButtonImage && playButtonImage) {
            const isPaused = marquee.classList.toggle('is-paused');
            if (isPaused) {
              pauseButtonImage.classList.remove('is-visible');
              playButtonImage.classList.add('is-visible');
            } else {
              playButtonImage.classList.remove('is-visible');
              pauseButtonImage.classList.add('is-visible');
            }
          }
        });

        pausePlayButton.addEventListener('keydown', (e) => {
          if (e.key != 'Enter' || e.key != 'Space') {
            return;
          }

          if (pauseButtonImage && playButtonImage) {
            const isPaused = marquee.classList.toggle('is-paused');
            if (isPaused) {
              pauseButtonImage.classList.remove('is-visible');
              playButtonImage.classList.add('is-visible');
            } else {
              playButtonImage.classList.remove('is-visible');
              pauseButtonImage.classList.add('is-visible');
            }
          }
        });
      }
    }
  };

  window.customElements.define('scrolling-banner', ScrollingBanner);
}
